import React, {useEffect} from 'react';
import {useModalContext} from '../../../modalContext.js';

import {useSidebarContext} from '../../../SidebarContext.js';
import {Aside} from '../aside/Aside.js';
import {ModalCloseBtn} from '../../../shared-components/custom-features/app-element/Btn.js';

export const CollapsibleSidebar = ({show, onHide, children, title}) => {
    const {isInModal} = useModalContext();
    const {sidebarOpen, sidebarClosing, openSidebar, closeSidebar} = useSidebarContext();
    // When the parent component wants the sidebar to open or close, we need to update the context accordingly
    useEffect(() => {
        if (show) {
            openSidebar();
        } else {
            closeSidebar();
        }
    }, [show, openSidebar, closeSidebar, onHide]);

    return (
        <Aside show={sidebarOpen} closing={sidebarClosing} isPopupModal={isInModal}>
            {title && (
                <Aside.Header>
                    {title}
                    <ModalCloseBtn onClick={() => closeSidebar(onHide)} />
                </Aside.Header>
            )}
            {children}
        </Aside>
    );
};
